import * as types from '../actionTypes/annualReturn'

export function getAnnualReturnsForLobbyist(lobbyistAnnualReturns) {
  return {
    type: types.GET_ANNUAL_RETURN_FOR_LOBBYIST,
    lobbyistAnnualReturns
  }
}

export function getAnnualReturn(annualReturn) {
  return {
    type: types.GET_ANNUAL_RETURN,
    annualReturn
  }
}

export function getChangesRequired(changesRequired) {
  return {
    type: types.GET_CHANGES_REQUIRED,
    changesRequired
  }
}

export function clearAnnualReturnsFromLobbyist() {
  return {
    type: types.CLEAR_ANNUAL_RETURNS_FOR_LOBBYIST
  }
}



// WEBPACK FOOTER //
// ./src/actions/annualReturn.js